import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {formatNumber} from "../cabinetShell/config";

import art from '../../theme/assets/redesign/hero.webp';
import usdtIcon from '../../theme/assets/redesign/wallet/token_usdt.svg';
import ftfIcon from '../../theme/assets/redesign/wallet/token_ftf.webp';
import swapIcon from '../../theme/assets/redesign/wallet/swap.svg';
import swapIconMob from '../../theme/assets/redesign/wallet/swap_mobile.svg';


const CabinetWalletMain = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const userData = useSelector(store => store.cabinet.userData);

    return (
        <section className={Styles.container}>
            <div className={Styles.art}>
                <img src={art} alt=""/>
            </div>
            <div className={Styles.title}>{t('Ваш баланс')}</div>
            <div className={Styles.balances}>
                <div className={Styles.token}>
                    <div className={Styles.tokenName}>
                        <img src={usdtIcon} alt="" width="32" height="32"/>
                        <span className={Styles.green}>USDT</span>
                    </div>
                    <div className={Styles.amount}>{formatNumber(userData?.user?.usdt)}</div>
                </div>
                {/* обмен USDT <-> FTF происходит через покупку/продажу на странице CFP */}
                <button type="button" className={Styles.swap} onClick={() => navigate('/matrix')} aria-label={t('Обмен')}>
                    <img className={Styles.desktopOnly} src={swapIcon} alt="" width="44" height="44"/>
                    <img className={Styles.mobileOnly} src={swapIconMob} alt="" width="44" height="44"/>
                </button>
                <div className={`${Styles.token} ${Styles.tokenRight}`}>
                    <div className={Styles.tokenName}>
                        <img src={ftfIcon} alt="" width="32" height="32"/>
                        <span className={Styles.red}>FTF</span>
                    </div>
                    <div className={Styles.amount}>{formatNumber(userData?.user?.tokens)}</div>
                </div>
            </div>
        </section>
    );
};

export default CabinetWalletMain;
